import ReviewPage from './ReviewPage';

export default ReviewPage;